import axios from 'axios';
import { smallNotification, messageNotification } from '@shared/services/gf.notification.service';
import { FORM_NAME_ENUMS } from '@shared/variables/form-name.enums';
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import HelperS from '../../services/helper.service';
import store from '../../../store';
import qs from 'qs';

export default {
  addApproverRule(alias, projectAlias, data) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/approval/rule`, data, {
        formName: FORM_NAME_ENUMS.APPROVAL_RULE_FORM
      })
      .then((res) => {
        smallNotification('success', { title: 'Правило добавлено!' });
        store.dispatch('addApprovalRule', res.data);
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  editApproverRule(alias, projectAlias, data) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/approval/rule`, data, {
        formName: FORM_NAME_ENUMS.APPROVAL_RULE_FORM
      })
      .then((res) => {
        smallNotification('success', { title: 'Правило изменено!' });
        store.dispatch('editApprovalRule', res.data);
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  getApproverRules(alias, projectAlias, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/approval/rule`, { params })
      .then((res) => {
        store.dispatch('setApprovalRules', {
          ...HelperS.parsePagination(res.data),
          items: [...HelperS.parsePagination(res.data).items].map((item) => ({
            ...item,
            targetBranch: {
              ...item.targetBranch,
              title: item.targetBranch.id
            }
          }))
        });
        return res.data;
      });
  },
  getApprovalConfig(alias, projectAlias, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/approval/configuration`, { params })
      .then((res) => res.data);
  },
  saveApprovalConfig(alias, projectAlias, data) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/approval/configuration`, data)
      .then((res) => {
        smallNotification('success', { title: 'Настройки сохранены!' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  saveMergeRequestMethodType(alias, projectAlias, data) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/setting/merge-request-method`, null, {
        params: { methodType: data }
      })
      .then((res) => {
        smallNotification('success', { title: 'Настройки сохранены!' });
      })
      .catch((e) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
      });
  },
  deleteRule(rule) {
    return axios
      .delete(
        `/api/project/${rule.project.ownerAlias}/${rule.project.selectorAlias}/approval/rule/${rule.id}`
      )
      .then(() => {
        smallNotification('success', { title: 'Правило удалено!' });
        store.dispatch('deleteApprovalRule', rule);
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  getMergeRequestApprovedBy(alias, projectAlias, mergeRequestId) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/approved-by`)
      .then((res) => {
        store.dispatch('setMergeRequestApprovedBy', res.data);
        return res.data;
      });
  },
  getMergeRequestApprovedByMe(alias, projectAlias, mergeRequestId) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/approved-by-user`)
      .then((res) => res.data);
  },
  approveRequest(alias, projectAlias, mergeRequestId) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/approve`)
      .catch((err) => {
        if (err.response.data.detail) {
          messageNotification('danger', {
            message: err.response.data.detail,
            hasTimeline: false
          });
        } else {
          smallNotification('danger', { title: 'Произошла ошибка' });
        }
        throw err;
      });
  },
  getAutoMergeConfig(alias, projectAlias) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/setting/auto-merge`)
      .then((res) => res.data);
  },
  saveAutoMergeConfig(alias, projectAlias, data) {
    return axios
      .put(`/api/project/${alias}/${projectAlias}/setting/auto-merge`, data)
      .then((res) => {
        smallNotification('success', { title: 'Настройки сохранены!' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  importApproverSettings(alias, projectAlias) {
    return axios
      .post(
        `/api/project/${alias}/${projectAlias}/setting/configuration-and-rule/import-protection`
      )
      .then((res) => res.data);
  },
  saveSquashCommitConfig(alias, projectAlias, data) {
    return axios
      .post(
        `/api/project/${alias}/${projectAlias}/setting/merge-request-squash`,
        qs.stringify(data)
      )
      .then((res) => {
        smallNotification('success', { title: 'Настройки сохранены!' });
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },

  getMergeMessagesTemplates(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/setting/approver/message`, {
        params
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },

  postMergeMessagesTemplates(userAlias, projectAlias, data, params) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/setting/approver/message`, data, {
        params
      })
      .then((res) => {
        smallNotification('success', { title: 'Настройки сохранены!' });
        return res;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  }
};

